export default (app) => {
    app.directive('tip', {
        mounted(el) {
            const eventName = 'ontouchstart' in window ? 'touchstart' : 'mouseenter';
            const handler = () => {
                setTimeout(() => {
                    const parent = el.offsetParent || el.parentElement;
                    if (!parent) return;
                    const ewidth = el.offsetWidth;
                    const pwidth = parent.offsetWidth;
                    const left = el.offsetLeft;
                    if (left < 120) {
                        el.classList.add('left');
                        el.classList.remove('right');
                        el.style.removeProperty('--right-spacing');
                    } else if (left + ewidth > pwidth - 120) {
                        el.classList.add('right');
                        el.classList.remove('left');
                        el.style.setProperty('--right-spacing', `${left + ewidth - pwidth}px`);
                    } else {
                        el.classList.remove('left');
                        el.classList.remove('right');
                        el.style.removeProperty('--right-spacing');
                    }
                }, 0);
            };
            el._tipHandler = handler;
            el.addEventListener(eventName, handler);
        },
        beforeUnmount(el) {
            const eventName = 'ontouchstart' in window ? 'touchstart' : 'mouseenter';
            if (el._tipHandler) {
                el.removeEventListener(eventName, el._tipHandler);
                delete el._tipHandler;
            }
        },
    });
};
